module.exports = __webpack_public_path__ + "static/media/tower.08d2df45.png";